// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { hideBet, removeBetFromFavorites, removeHideBet } from '../../actions/betslipOptions';
import { useBetslipOptionsContext } from '../../context/BetslipOptionsContext';

import BetslipOptionsHideItem from './BetslipOptionsHideItem';
import makeBetslipOptionsHideItemPropsSelector from './BetslipOptionsHideItem.selector';

const BetslipOptionsHideItemContainer = () => {
  const dispatch = useDispatch();
  const { betslipId } = useBetslipOptionsContext();
  const selector = useMemo(() => makeBetslipOptionsHideItemPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, { betslipId }));

  const onToggleHide = useCallback(() => {
    if (selectedProps.isHidden) {
      dispatch(removeHideBet(betslipId));
    } else {
      dispatch(removeBetFromFavorites(betslipId));
      dispatch(hideBet(betslipId));
    }
  }, [betslipId, dispatch, selectedProps.isHidden]);

  const otherProps = useMemo(() => ({ onToggle: onToggleHide }), [onToggleHide]);

  const enhancedProps = useMergeProps({ otherProps, selectedProps });

  return <BetslipOptionsHideItem {...enhancedProps} />;
};

export default BetslipOptionsHideItemContainer;
